module.exports = __webpack_public_path__ + "static/council-7476a1ee1d625bbdb3c29d7fdbed823f.png";